import React, {useEffect, useState} from 'react';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import {Row, Col, Container} from "react-bootstrap";
import Select from 'react-select';
import { Storage } from "@aws-amplify/storage";
import Alert from 'react-bootstrap/Alert';

// import Amplify from 'aws-amplify';
import { Amplify } from 'aws-amplify';
import awsconfig from '../aws-exports';
Amplify.configure(awsconfig);

const optionList = [
    { value: "degree-certificate-translation", label: "Degree Certificate Translation" },
    { value: "import-permit-translation", label: "Import Permit Translation" },
    { value: "drivers-license-translation", label: "Driver's License Translation" },
    { value: "identity-card-translation", label: "Identify Card Translation" },
    { value: "marriage-certificate-translation", label: "Marriage Certificate Translation" },
    { value: "other", label: "Other" },
    
];

const langs = [
    { value: "english-uk", label: "English (UK)" },
    { value: "english-us", label: "English (US)" },
    { value: "hindi", label: "Hindi" },
    { value: "urdu", label: "Urdu" },
    { value: "french", label: "French" },
    
];


const CostCalculator = () => {
    const defaultCustData ={
        currency:"USD",
        pageCount:0,
        wordCount: 0,
        docType: 'letter',
        email:"",
        fullName:"",
        phone:"",
        langFrom:"",
        langTo:"",
        addDetail:"",
        fileName:"",
        filePath:""
    };
    const [selectedOptions, setSelectedOptions] = useState();
    const [langsFrom, setLangsFrom] = useState();
    const [langsTo, setLangsTo] = useState();
    const [custData, setCustData] = useState(defaultCustData);
    const [dataSubmitAlert, setDataSubmitAlert] = useState(false);
    //const [show, setShow] = useState(true);

    function handleFormChange(e){
        setCustData({...custData, [e.target.name]:e.target.value})
    }

    function handleSelect(data) {
        setCustData({...custData, ["docType"]: data.value});
    }

    function handleLangsFrom(data){
        setCustData({...custData, ["langFrom"]: data.value});
    }

    function handleLangsTo(data){
        setCustData({...custData, ["langTo"]: data.value});
    }

    function handleFileUpload(e){
        let splitTest = function (str) {
            return str.split('\\').pop().split('/').pop();
        }
        const fileName = splitTest(e.target.value);
        setCustData({...custData, ["fileName"]: fileName});
        setCustData({...custData, ["filePath"]: e.target.file});
    }


    const [file, setFile] = useState(null);

    const handleChange = (event) => {
        const file = event.target.files[0];
        setFile(file);
    };

    const handleUpload = async () => {
        try {
        await Storage.put(file.name, file,{
            level:'private'
        });
        console.log('File uploaded successfully');
        } catch (error) {
        console.error('Error uploading file:', error);
        }
    };
    
    function handleFormSubmit() {
        //Upload file
        handleUpload();
        //Generate random id for database
        const date = new Date();
        let orderId = Math.floor(date.getFullYear().toString()+ date.getMonth().toString() + date.getDay().toString() + (Math.random()*9999));
        
        //Create an order to the database using GraphQL
        var myHeaders = new Headers();
        myHeaders.append("x-api-key", "da2-y6osasbopbfgpppa7h6rmiipza");
        myHeaders.append("Content-Type", "application/json");

        var graphql = JSON.stringify({
        query: "mutation CreateOrder($_version: Int = 10, $additionalDetails: String = \"test\", $amount: String = \"\", $currency: String = \"\", $custName: String = \"test\", $docType: String = \"test\", $email: AWSEmail = \"test@gmail.com\", $id: ID = \"1\", $isCompleted: String = \"new\", $langFrom: String = \"hindi\", $langTo: String = \"english\", $orderAccepted: Boolean = false, $pageCount: Int = 10, $paymentStatus: String = \"done\", $payment_mode: String = \"\", $phone: String = \"test\", $uploadedFile: AWSURL = \"https://abce.com\", $wordCount: Int = 10) {\r\n  createZeeepyOrders(input: {_version: $_version, additionalDetails: $additionalDetails, custName: $custName, docType: $docType, email: $email, id: $id, isCompleted: $isCompleted, langFrom: $langFrom, langTo: $langTo, orderAccepted: $orderAccepted, pageCount: $pageCount, paymentStatus: $paymentStatus, phone: $phone, wordCount: $wordCount, amount: $amount, currency: $currency, payment_mode: $payment_mode, uploadedFile: $uploadedFile}) {\r\n    id\r\n  }\r\n}\r\n",
        variables: {
            "additionalDetails":custData.addDetail,
            "amount":0,
            "currency":custData.currency,
            "custName":custData.fullName,
            "docType":custData.docType,
            "email":custData.email,
            "id":orderId,
            "isCompleted":"new",
            "langFrom":custData.langFrom,
            "langTo":custData.langTo,
            "orderAccepted":true,
            "pageCount":custData.pageCount,
            "payment_mode":"online",
            "paymentStatus":"incomplete",
            "phone":custData.phone,
            "uploadedFile":custData.fileName,
            "wordCount":custData.wordCount}
        })
        
        var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: graphql,
        redirect: 'follow'
        };

        fetch("https://jqicdf3rkrcs7gesue3flieeru.appsync-api.eu-north-1.amazonaws.com/graphql?additionalDetails", requestOptions)
        .then(response => {
            if(response.ok){
              setDataSubmitAlert(true); 
              console.log("Customer Data: ", custData);
            }   
            return response.text();
        })
        //.then(response => response.text())
        .then(result => {
            console.log(result);
        })
        .catch(error => console.log('error', error));


    }
    useEffect(()=>{
        
        
    },[custData])

  return (
    <>
    <div className='cost-calculator'>
        <div className='headings'>
            <h4>Get Quote</h4>
            <h6>
                <span className='cost' id="cost" style={{marginRight:"4px"}}>Currency</span>
                <select className='currency-selector' value={custData.currency} name='currency' onChange={handleFormChange}>
                    <option value={"USD"}>USD</option>
                    <option value={"SGD"}>SGD</option>
                    <option value={"MMR"}>MMR</option>
                    <option value={"INR"}>INR</option>
                    <option value={"EURO"}>Euro</option>
                    <option value={"GBP"}>GBP</option>
                </select>
                
            </h6>
        </div>

        <div className='calc-form'>
            <Form>
                <Row>
                    <Col xs={6}>
                        <Form.Group className="mb-3" controlId="formBasicEmail">
                            <Form.Label>Page Count <span style={{color:"red"}}>*</span></Form.Label>
                            <Form.Control type="number" value={custData.pageCount} placeholder="1" name="pageCount" onChange={handleFormChange} />
                        </Form.Group>
                    </Col>
                    <Col xs={6}>
                        <Form.Group className="mb-3" controlId="formBasicEmail">
                            <Form.Label>Word Count (Optional)</Form.Label>
                            <Form.Control type="number" value={custData.wordCount} placeholder="100" name="wordCount" onChange={handleFormChange} />
                        </Form.Group>
                    </Col>
                    <Col xs={12}>
                        
                        <div className="dropdown-container">
                        <Form.Group className="mb-3" controlId="formBasicEmail">
                            <Form.Label>Document Type <span style={{color:"red"}}>*</span> </Form.Label>
                            <Select
                                options={optionList}
                                placeholder="Document Type"
                                value={selectedOptions}
                                //value={custData.docType}
                                onChange={handleSelect}
                                isSearchable={true}
                                required
                                name="docType"
                                //onChange={handleFormChange}
                            />
                        </Form.Group>
                        
                        </div>
                    </Col>
                    {/* <Col xs={4}>
                        <button className='btn btn-danger calc-button'>Calculate</button>
                    </Col> */}
                </Row>

                <Row>
                    <Col xs={12}>
                        <div className=''>
                        <Form.Group className="mb-3" controlId="formBasicEmail">
                            <Form.Label>Email address <span style={{color:"red"}}>*</span></Form.Label>
                            <Form.Control type="email" value={custData.email} name="email" onChange={handleFormChange} placeholder="Enter email" required/>
                        </Form.Group>
                        </div>
                    </Col>
                    <Col xs={12}>
                        <div className=''>
                        <Form.Group className="mb-3" controlId="formText">
                            <Form.Label>Full Name <span style={{color:"red"}}>*</span></Form.Label>
                            <Form.Control type="text" value={custData.fullName} onChange={handleFormChange} name="fullName" placeholder="Your Full Name" required/>
                        </Form.Group>
                        </div>
                    </Col>
                    <Col xs={12}>
                        <div className=''>
                        <Form.Group className="mb-3" controlId="formText">
                            <Form.Label>Phone Number <span style={{color:"red"}}>*</span></Form.Label>
                            <Form.Control type="text" value={custData.phone} onChange={handleFormChange} name="phone" placeholder="+1 xxxxx xxxxx" required/>
                        </Form.Group>
                        </div>
                    </Col>
                    <Col xs={6}>
                        <div className="dropdown-container">
                            <Form.Group className="mb-3" controlId="formBasicEmail">
                                <Form.Label>Language From <span style={{color:"red"}}>*</span></Form.Label>
                                {/* <Form.Control type="number" placeholder="1" /> */}
                                <Select
                                    options={langs}
                                    placeholder="Language From"
                                    value={langsFrom}
                                    //value={custData.langFrom}
                                    onChange={handleLangsFrom}
                                    isSearchable={true}
                                    required
                                    name="langFrom"
                                />
                            </Form.Group>
                        
                        </div>
                    </Col>
                    <Col xs={6}>
                        <div className="dropdown-container">
                            <Form.Group className="mb-3" controlId="formBasicEmail">
                                <Form.Label>Language To <span style={{color:"red"}}>*</span></Form.Label>
                                {/* <Form.Control type="number" placeholder="1" /> */}
                                <Select
                                    options={langs}
                                    placeholder="Language To"
                                    value={langsTo}
                                    //value={custData.langTo}
                                    //onChange={handleLangsTo}
                                    isSearchable={true}
                                    required
                                    name="langTo"
                                />
                            </Form.Group>
                        
                        </div>
                    </Col>
                    <Col xs={12}>
                        <div className=''>
                        <Form.Group className="mb-3" controlId="formText">
                            <Form.Label>Additional Details</Form.Label>
                            <Form.Control as="textarea" value={custData.addDetail} onChange={handleFormChange} rows={1} name="addDetail" placeholder="Additional Details about document" required/>
                        </Form.Group>
                        </div>
                    </Col>
                    <Col xs={12}>
                        <div className=''>
                        <Form.Group className="mb-3" controlId="formText">
                            <Form.Label>Upload File <span style={{color:"red"}}>*</span> </Form.Label>
                            <Form.Control type="file" onChange={handleChange} name="fileName" rows={1} placeholder="Your Full Name" required/>
                        </Form.Group>
                        </div>
                    </Col>
                    <Col xs={4}>
                        <div className=''>
                        <button type='button' className='btn btn-submit' onClick={handleFormSubmit}>Submit</button>
                        </div>
                    </Col>
                </Row>
                
                
            </Form>
            {dataSubmitAlert? 
                <Alert key={"success"} onClose={() => setDataSubmitAlert(false)} variant={"success"} style={{marginTop:"10px"}} dismissible>
                    <p style={{marginBottom: 0}}>Request submitted successfully!</p>
                </Alert>
                :""}
        </div>
    </div>

    </>
  )
}

export default CostCalculator